import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/useLanguage";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { localize } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SeoHead
        title={{
          en: "404 - Page Not Found | AI-labbet",
          sv: "404 - Sidan hittades inte | AI-labbet",
        }}
        description={{
          en: "The page you're looking for doesn't exist. Return to AI-labbet's homepage to explore our AI strategy, governance, and skilling services.",
          sv: "Sidan du letar efter finns inte. Återvänd till AI-labbets startsida för att utforska våra tjänster inom AI-strategi, styrning och kompetens.",
        }}
        path={location.pathname}
        noIndex
      />

      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center bg-background px-4">
          <div className="text-center max-w-md">
            <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
            <p className="mb-2 text-2xl font-semibold text-foreground">{t("notFound.heading")}</p>
            <p className="mb-8 text-muted-foreground">{t("notFound.body")}</p>
            <Button variant="primary" asChild size="lg">
              <Link to={localize("/")}>{t("notFound.cta")}</Link>
            </Button>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
